/**
 * Domain features the backend lists in the authenticated user's `features` array.
 *
 * Only the names the client reacts to belong here; the server is free to send others.
 */
export enum DomainFeature {
  PortalWidget = 'portalWidget',
  BlockFullStory = 'blockFullStory',
}
